module.exports = __webpack_public_path__ + "img/ProcessImprovement2.285ec50f.jpg";